<template>
  <div class="container mt-5 mb-5">
    <div class="sections-menu">
      <div
        class="manu-option"
        style="margin: 10px 15px; cursor:pointer"
        v-bind:class="{ active: activeSection == index }"
        v-on:click="scrollToSection(index)"
        v-for="(offset, index) in offsets"
        v-bind:key="index"
      >
        <h5>{{ titles[index] }}</h5>
      </div>
    </div>
    <section>
      <Apresentacao />
    </section>
    <section>
      <Caracteristicas />
    </section>
    <section>
      <Aplicacoes />
    </section>
    <section class>
      <Passagem />
    </section>
    <section class>
      <Seguranca />
    </section>
    <section class>
      <Exemplos />
    </section>
    <section class>
      <Plataforma />
    </section>
    <section class>
      <Canaletas />
    </section>
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-info btn-to-top">
        <font-awesome-icon icon="chevron-up" />
      </button>
    </back-to-top>
  </div>
</template>

<script>
import Apresentacao from "@/pages/grades/Apresentacao";
import Caracteristicas from "@/pages/grades/Caracteristicas";
import Aplicacoes from "@/pages/grades/Aplicacoes";
import Passagem from "@/pages/grades/Passagem";
import Seguranca from "@/pages/grades/Seguranca";
import Exemplos from "@/pages/grades/Exemplos";
import Plataforma from "@/pages/grades/Plataforma";
import Canaletas from "@/pages/grades/Canaletas";
// Json Content
import json from "../assets/content.json";
export default {
  name: "Grades",
  data: function() {
    return {
      content: json,
      inMove: false,
      activeSection: 0,
      offsets: [],
      titles: [],
      touchStartY: 0,
    };
  },

  methods: {
    // Get offset of each section element
    calculateSectionOffsets() {
      let sections = document.getElementsByTagName("section");

      let length = sections.length;

      for (let i = 0; i < length; i++) {
        let sectionOffset = sections[i].offsetTop;

        this.offsets.push(sectionOffset);
      }
    },

    scrollToSection(id, force = false) {
      if (this.inMove && !force) return false;

      this.activeSection = id;

      this.inMove = true;

      document.getElementsByTagName("section")[id].scrollIntoView({ behavior: "smooth" });

      setTimeout(() => {
        this.inMove = false;
      }, 400);
    },
    createTitles() {
      for (let x in this.content.grades) {
        this.titles.push(this.content.grades[x]);
      }
    },
  },

  created() {
    this.createTitles();
  },

  // Add listeners and calculate offset on mount
  mounted() {
    this.calculateSectionOffsets();

    window.addEventListener("touchstart", this.touchStart, {
      passive: false,
    }); // mobile devices

    window.addEventListener("touchmove", this.touchMove, { passive: false }); // mobile devices
  },

  // Remove listeners on unmount
  destroyed() {
    window.removeEventListener("touchstart", this.touchStart); // mobile devices

    window.removeEventListener("touchmove", this.touchMove); // mobile devices
  },

  components: {
    Apresentacao,
    Caracteristicas,
    Aplicacoes,
    Passagem,
    Seguranca,
    Exemplos,
    Plataforma,
    Canaletas,
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_standard.scss";
section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
}

.sections-menu {
  display: flex;
  flex-flow: column;
  position: relative;
  z-index: 2;
  background-color: $primary;
  align-items: center;
  color: #fff;

  h5 {
    font-size: 16px;
  }

  @media (min-width: 995px) {
    position: sticky;
    top: 0%;
    flex-flow: row;
  }
}

.background-blue {
  background-color: $primary-background;
}

.img-shadow-blue {
  box-shadow: 10px -10px 0px $primary;
}

.space-top-desktop {
  @media (min-width: 768px) {
    margin-top: 50px;
  }
}
.space-top-mobile {
  @media (max-width: 768px) {
    margin-top: 50px;
  }
}
.space-bottom-mobile {
  @media (max-width: 768px) {
    margin-bottom: 50px;
  }
}
.sec-img {
  @media (max-width: 768px) {
    margin-top: 50px;
  }
}

.btn-to-top {
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

@media screen and (max-width: 1200px) {
  h1 {
    font-size: 2.5em;
  }
}
</style>
